import React from "react";
import { autoDetectedPackage } from "@/lib/utils";

/**
 * Inline forfait selector for a single game row in the schedule view.
 * - "Auto" : forfait calculé à partir des assignations (A/B/C/D)
 * - A/B/C/D : forfait forcé par l'admin (persisté sur game.package_override)
 *
 * Affiche un badge gris si Auto, noir si override actif.
 */
export default function PackagePicker({ game, packages = {}, onChange }) {
  const auto = autoDetectedPackage(game);
  const override = game?.package_override || "";
  const effective = override || auto;
  const isOverride = !!override;

  return (
    <div className="flex items-center gap-1" data-testid={`package-picker-${game.id}`}>
      <select
        value={override}
        onChange={(e) => onChange(e.target.value || null)}
        className={`bg-transparent text-xs font-mono uppercase tracking-wider border ${
          isOverride ? "border-black bg-black text-white" : "border-[var(--border-strong)] text-[var(--muted)]"
        } px-1.5 py-0.5 cursor-pointer outline-none focus:border-black hover:border-black`}
        title={
          isOverride
            ? `Forfait forcé : ${override}${packages[override]?.label ? " · " + packages[override].label : ""}`
            : auto
            ? `Auto-détecté : ${auto}${packages[auto]?.label ? " · " + packages[auto].label : ""}`
            : "Aucune assignation"
        }
        data-testid={`package-select-${game.id}`}
      >
        <option value="">{auto ? `Auto (${auto})` : "Auto"}</option>
        {["A", "B", "C", "D"].map((k) => (
          <option key={k} value={k}>
            {k}{packages[k]?.label ? ` · ${packages[k].label}` : ""}
          </option>
        ))}
      </select>
      {!effective && (
        <span className="font-mono text-[9px] uppercase tracking-widest text-[var(--muted-2)]" title="Aucun officiel assigné">—</span>
      )}
    </div>
  );
}
